import { syncNow } from '../data/sync';

/**
 * "Refresh": pull the latest from the server and make sure the app itself is the newest build.
 * The web app asks the server which build is current and reloads onto it; the Android app
 * re-checks for an APK (the update prompt listens for this).
 */

let registration: ServiceWorkerRegistration | null = null;

export function setServiceWorker(reg: ServiceWorkerRegistration) {
  registration = reg;
}

/** Reloads onto a newer web build if the server has one. `quiet` skips while I'm typing. */
export async function checkWebVersion(quiet = true): Promise<boolean> {
  if (!navigator.onLine) return false;
  await registration?.update().catch(() => {});
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    const { build } = (await res.json()) as { build: string };
    if (!build || build === __BUILD_TIME__) return false;
    const typing = document.activeElement?.matches('input, textarea, [contenteditable]');
    // Once per build when it's automatic, so a failed update can't keep reloading the page.
    const key = 'trips.reloadedFor';
    if (quiet && (typing || sessionStorage.getItem(key) === build)) return false;
    sessionStorage.setItem(key, build);
    location.reload();
    return true;
  } catch {
    return false;
  }
}

export const UPDATE_CHECK_EVENT = 'trips:check-update';

export async function refreshAll(): Promise<void> {
  if (__NATIVE__) window.dispatchEvent(new Event(UPDATE_CHECK_EVENT));
  else if (!__PREVIEW__ && (await checkWebVersion(false))) return;
  await syncNow();
}
